!function ($) {

	"use strict";

	var fallbackEventName = 'transitionEndFallback';

	window.transitionEndEvent = function () {
		return (typeof $.support.transition.end == 'undefined') ? fallbackEventName : $.support.transition.end;
	};

	$.fn.triggerTransitionEndFallback = function () {
		if (transitionEndEvent() == fallbackEventName) {
			$(this).trigger(fallbackEventName);
		}
	};

}(window.jQuery);
